import { Component, OnInit, Injector } from '@angular/core';
import { PageableComponent } from './PageableComponent';

@Component({
  selector      : 'AdminOnlyPageComponent',
  templateUrl   : 'AdminOnlyPageComponent.html',
})
export class AdminOnlyPageComponent extends PageableComponent implements OnInit {

  constructor(pageable_injector: Injector)
  {
    super(pageable_injector);

    if (!this._userService.isSuperuser())
    {
      this._router.navigate(['/403']);
    }

  }

  ngOnInit() 
  {

  }

}
